var map = {
	"./1.png": 913,
	"./10.png": 3125,
	"./11.png": 4028,
	"./12.png": 4087,
	"./13.png": 5774,
	"./14.png": 6785,
	"./2.png": 330,
	"./3.png": 5539,
	"./4.png": 668,
	"./5.png": 7205,
	"./6.png": 3198,
	"./7.png": 2423,
	"./8.png": 2512,
	"./9.png": 8761
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2649;